import { render, staticRenderFns } from "./ModalDragAndDropMoverMultiplesDocumentos.vue?vue&type=template&id=6fda5260&scoped=true"
import script from "./ModalDragAndDropMoverMultiplesDocumentos.vue?vue&type=script&lang=js"
export * from "./ModalDragAndDropMoverMultiplesDocumentos.vue?vue&type=script&lang=js"
import style0 from "./ModalDragAndDropMoverMultiplesDocumentos.vue?vue&type=style&index=0&id=6fda5260&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fda5260",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fda5260')) {
      api.createRecord('6fda5260', component.options)
    } else {
      api.reload('6fda5260', component.options)
    }
    module.hot.accept("./ModalDragAndDropMoverMultiplesDocumentos.vue?vue&type=template&id=6fda5260&scoped=true", function () {
      api.rerender('6fda5260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/repositorio/ModalDragAndDropMoverMultiplesDocumentos.vue"
export default component.exports